<template>
  <div class="layout-pods orders">
    <campaign-adjustments-modal
      :show="adjustmentModalVisible"
      :campaign="adjustmentModalCampaign"
      @on-close-clicked="adjustmentModalClosed"
    ></campaign-adjustments-modal>
    <transition name="modal">
      <modal :short="true" v-if="modalVisible">
        <template slot="modal-header">
          <div class="header-wrapper">
            <h2 class="section-heading">
              Notes for
              <span style="text-decoration: underline;">{{
                modalCampaignTitle
              }}</span
              >:
            </h2>
          </div>
        </template>

        <template slot="modal-body">
          <div class="p-4">
            <vue-good-table
              :columns="notesColumns"
              :rows="notes"
              :sort-options="sortOptions"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'createdBy'">
                  {{ parseInitials(props.formattedRow[props.column.field]) }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <template slot="emptystate">
                <p style="text-align: center;" class="mb-0">
                  No notes available to display.
                </p>
              </template>
            </vue-good-table>
          </div>
          <form class="p-4">
            <div class="mb-3">
              <textarea
                class="form-control"
                id="note"
                name="note"
                rows="4"
                placeholder="Add note"
                v-model="internalNote"
              ></textarea>
            </div>
            <div class="d-flex justify-content-between">
              <button
                type="button"
                class="btn btn-secondary"
                style="font-weight: bold"
                @click="hideModal()"
              >
                CANCEL
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                @click.prevent="submitNote"
                :disabled="!internalNote"
              >
                Add Note
              </button>
            </div>
          </form>
        </template>
      </modal>
    </transition>

    <transition name="modal">
      <modal :short="true" v-if="focModalVisible">
        <template slot="modal-header">
          <div class="header-wrapper"></div>
        </template>

        <template slot="modal-body">
          <div class="p-4">
            <form class="p-4">
              <div class="mb-3">
                <textarea
                  class="form-control"
                  id="note"
                  name="note"
                  rows="4"
                  placeholder="Free of Charge Note"
                  v-model="foc"
                ></textarea>
              </div>
              <div class="d-flex justify-content-between">
                <button
                  type="button"
                  class="btn btn-secondary"
                  style="font-weight: bold"
                  @click="hideFocModal()"
                >
                  CANCEL
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  @click.prevent="submitFoc"
                  :disabled="!foc"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </template>
      </modal>
    </transition>

    <header class="layout-pods-header pg-header">
      <div></div>
    </header>
    <div class="">
      <div class="row">
        <div class="col-12">
          <template>
            <div>
              <div class="row">
                <div class="col-12 col-md-12 col-lg-9 filter-elements">
                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <client-list-dropdown
                      :value="selectedClients"
                      @on-client-selected="handleClientSelected"
                      @on-client-removed="handleClientRemoved"
                    />
                  </div>

                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <agency-list-dropdown
                      :client-ids="agenciesDropdownFilter"
                      :value="selectedAgencies"
                      :multiple="true"
                      @on-agency-selected="handleAgencySelected"
                      @on-agency-removed="handleAgencyRemoved"
                      :disabled="noClientSelected"
                    />
                  </div>

                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <order-status-dropdown
                      :value="selectedStatuses"
                      :multiple="true"
                      @on-order-status-selected="handleStatusSelected"
                      @on-order-status-removed="handleStatusRemoved"
                      :disabled="noClientSelected"
                    />
                  </div>

                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <order-invoice-dropdown
                      :value="selectedInvoice"
                      @on-invoice-selected="handleInvoiceSelected"
                      @on-invoice-removed="handleInvoiceRemoved"
                      :disabled="noClientSelected"
                    />
                  </div>
                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <order-type-dropdown
                      :value="selectedOrderTypes"
                      :multiple="true"
                      @on-order-type-selected="handleOrderTypeSelected"
                      @on-order-type-removed="handleOrderTypeRemoved"
                      :disabled="noClientSelected"
                    />
                  </div>
                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <package-list-dropdown
                      :value="selectedPackages"
                      :multiple="true"
                      @on-package-selected="handlePackageSelected"
                      @on-package-removed="handlePackageRemoved"
                      :disabled="noClientSelected"
                    />
                  </div>

                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <div class="date-time-picker-container inline">
                      <DateTimePicker
                        color="#13a3eb"
                        class="mr-sm-2"
                        label="Filter by Start Date"
                        formatted="DD MMM YYYY"
                        format="YYYY-MM-DD"
                        v-model="startDateRange"
                        autoClose
                        input-size="sm"
                        range
                        noClearButton
                        noButton
                        :no-value-to-custom-elem="false"
                        only-date
                        :disabled="noClientSelected"
                      >
                      </DateTimePicker>
                    </div>
                  </div>

                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <div class="date-time-picker-container inline">
                      <DateTimePicker
                        color="#13a3eb"
                        class="mr-sm-2"
                        label="Filter by Booking Date"
                        formatted="DD MMM YYYY"
                        format="YYYY-MM-DD"
                        v-model="bookingDateRange"
                        autoClose
                        input-size="sm"
                        range
                        noClearButton
                        noButton
                        :no-value-to-custom-elem="false"
                        only-date
                        :disabled="noClientSelected"
                      >
                      </DateTimePicker>
                    </div>
                  </div>

                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <input
                      class="form-control"
                      type="search"
                      placeholder="Campaign ID"
                      aria-label="Campaign ID"
                      v-model="campaignId"
                    />
                  </div>

                  <div class="col-12 col-md-4 col-lg-3 pb-2 pr-2">
                    <form id="order-search" class="search-form order-search">
                      <input
                        class="form-control"
                        type="search"
                        placeholder="Search"
                        aria-label="Search"
                        v-model="searchText"
                        :disabled="noClientSelected"
                      />
                    </form>
                  </div>
                </div>
                <div
                  class="col-12 col-md-12 col-lg-3 justify-content-end filter-buttons"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <button
                        @click="getOrders"
                        class="btn btn-primary mr-3"
                        style="width: 100%"
                        :disabled="noClientSelected && !campaignId"
                      >
                        Display<br />Orders
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button
                        @click="clearFilters"
                        class="btn btn-quaternary mr-3"
                        style="width: 100%;"
                        :disabled="noClientSelected"
                      >
                        Clear<br />Filters
                      </button>
                    </div>
                    <!-- <div class="col-md-6 mt-2">
                      <button
                        @click="exportSignifiCSV"
                        v-if="$isAllowed('exportCsv') && selectedClients.length == 1 && selectedClients[0].title !== 'All Clients'"
                        class="btn btn-quaternary mr-3"
                        style="width: 100%"
                        :disabled="noClientSelected"
                      >
                        Export<br />Campaigns (Signifi)
                      </button>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="col-12">
          <vue-good-table
            mode="remote"
            :pagination-options="paginationOptions"
            :columns="columns"
            :rows="orders"
            :sort-options="sortOptions"
            :totalRows="totalRows"
            @on-page-change="handlePageChanged"
            styleClass="vgt-table"
            ><template slot="table-row" slot-scope="props">
              <!-- Invoiced -->
              <div
                class="c__checkbox d-flex align-items-center justify-content-center"
                v-if="
                  props.column.field === 'invoiced' &&
                    $isAllowed('updateInvoice')
                "
              >
                <input
                  type="checkbox"
                  v-bind:checked="props.formattedRow[props.column.field]"
                  @change="updateInvoice(props.row)"
                />
                <label style="margin-right: -12px">&nbsp;</label>
              </div>
              <!-- Campaign Display -->
              <span v-else-if="props.column.field === 'campaign.displayName'">
                <a
                  href="#"
                  target="_blank"
                  class="btn-link"
                  @click.prevent="goToDashboard(props.row)"
                >
                  {{ props.formattedRow[props.column.field] }}
                  <span v-if="$isAllowed('viewPrices')">
                    {{ props.row.packagePrice | formatCurrency }}
                    <template v-if="hasGst(props.row)"
                      >incl. GST</template
                    >
                    <template v-else
                      >excl. GST</template
                    >
                  </span></a
                >
                <span
                  v-if="props.row.status"
                  :class="{
                    'badge badge-in-progress':
                      props.row.status === 'In Progress',
                    'badge badge-finished': props.row.status === 'Finished',
                    'badge badge-booked': props.row.status === 'Booked',
                    'badge badge-cancelled': props.row.status === 'Cancelled',
                    'badge badge-stopped': props.row.status === 'Stopped',
                    'badge badge-draft': props.row.status === 'Draft',
                  }"
                  >{{ props.row.status }}</span
                >
                <span
                  v-if="props.row.statusLabel"
                  class="badge badge-status-label"
                  >{{ props.row.statusLabel }}</span
                >
              </span>
              <!-- Notes -->
              <span v-else-if="props.column.field === 'campaign.campaignNotes'">
                <div class="tooltip-container">
                  <button
                    style="cursor: pointer; text-decoration: underline;"
                    @click="
                      showModal(
                        props.row.campaign.id,
                        props.row.campaign.displayName
                      )
                    "
                  >
                    <img
                      :src="
                        props.row.campaign.campaignNotes.length > 0
                          ? require('../../assets/icons/note-icon.svg')
                          : require('../../assets/icons/note-icon-gray.svg')
                      "
                      alt="Add Note"
                      width="24px"
                    />
                  </button>
                  <div class="tooltip">
                    {{
                      props.row.campaign.campaignNotes.length > 0
                        ? `${
                            props.row.campaign.campaignNotes.length
                          } note(s) added. Click to view notes.`
                        : 'No notes available, click to add notes.'
                    }}
                  </div>
                </div>
              </span>
              <!-- Free of Charge -->
              <span v-else-if="props.column.field === 'campaign.foc'">
                <div>
                  <button
                    style="cursor: pointer; text-decoration: underline;"
                    @click="
                      showFocModal(
                        props.row.campaign.id,
                        props.row.campaign.statusLabel
                      )
                    "
                  >
                    <img
                      src="../../assets/icons/icon-add-primary.svg"
                      alt="Add Note"
                      width="24px"
                    />
                  </button>
                </div>
              </span>
              <!-- Finance Adjustments -->
              <span v-else-if="props.column.field === '-'">
                <button @click="showAdjustmentModal(props.row.campaign)">
                  <div style="width: 24px; height: 24px;">
                    <icon-finance-adjustments
                      :active="props.row.campaign.adjustmentDate"
                    ></icon-finance-adjustments>
                  </div>
                </button>
              </span>
              <!-- Campaign Type -->
              <span v-else-if="props.column.field === 'campaignType'">
                {{
                  campaignTypeNormalizer(
                    props.formattedRow[props.column.field]
                  ) | capitalizeTheFirstLetterOfEachWord
                }}
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
            <div slot="emptystate">
              <div v-if="noClientSelected">
                <app-action-needed
                  title="No client selected"
                  description="Please select a client to get started"
                />
              </div>
              <div v-else-if="noResults">
                <app-action-needed
                  title="No orders found"
                  description="We cant find any orders that match the given filter."
                />
              </div>
              <div v-else>
                <app-action-needed
                  title="Filters applied"
                  description="Click on 'Display Orders' to show results."
                />
              </div>
            </div>
            <div slot="table-actions">
              <div class="d-flex flex-row align-items-center">
                <p class="text-right bold mb-0 mr-3" style="width: 200px">
                  Total Orders: {{ totalRows }}
                </p>
                <button
                  class="btn btn-quaternary mr-3"
                  v-if="$isAllowed('exportCsv')"
                  @click="exportCSV"
                  :disabled="noClientSelected"
                >
                  EXPORT
                </button>
              </div>
            </div>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker';
import OrderService from '../../services/orders';
import OrderPerimeters from '../../configs/Perimeters/orders';
import {refreshPageMixin} from '../../mixins/refreshPage';
import {parse, addDays, format} from 'date-fns';
import Navigation from '../../configs/Perimeters/navigation';
import {mapGetters} from 'vuex';
import AgencyListDropdown, {
  AgencyListAllOption,
} from '../Agencies/AgencyListDropdown.vue';
import PackageListDropdown, {
  PackageListAllOption,
} from '../Packages/PackageListDropdown.vue';
import ClientListDropdown, {
  ClientListAllOption,
} from '../Clients/ClientListDropdown.vue';
import OrderStatusDropdown, {
  OrderStatusListAllOption,
} from './OrderStatusDropdown.vue';
import OrderInvoiceDropdown from './OrderInvoiceDropdown.vue';
import OrderTypeDropdown, {OrderTypeAllOption} from './OrderTypeDropdown.vue';
import {FilterBuilder} from '../../helpers/FilterBuilder';
import {OrderDropdownFilterSelectedHelper} from '../../helpers/OrderDropdownFilterSelectedHelper';
import AppActionNeeded from '../AppComponents/AppActionNeeded.vue';
import {StringToCapitalizedCase} from '../../helpers/StringToCapitalizedCase';
import {VueGoodTable} from 'vue-good-table';
import {
  COLUMNS,
  NOTES_COLUMNS,
  PAGINATION_OPTIONS,
  SORT_OPTIONS,
} from './OrdersListTableConfig';
import Modal from '../../helpers/Modal';
import CampaignServices from '../../services/campaigns';
import moment from 'moment';
import IconFinanceAdjustments from '../../assets/icons/icon-finance-adjustments.vue';
import ApiCallMixin from '../../mixins/ApiCallMixin';
import CampaignAdjustmentsModal from '../Campaigns/CampaignAdjustmentsModal.vue';

export default {
  mixins: [refreshPageMixin, ApiCallMixin],
  perimeters: [OrderPerimeters],
  components: {
    DateTimePicker,
    AgencyListDropdown,
    PackageListDropdown,
    ClientListDropdown,
    OrderStatusDropdown,
    OrderInvoiceDropdown,
    OrderTypeDropdown,
    AppActionNeeded,
    VueGoodTable,
    Modal,
    IconFinanceAdjustments,
    CampaignAdjustmentsModal,
  },
  data() {
    return {
      selectedClients: [],
      selectedAgencies: [],
      selectedStatuses: [],
      selectedInvoice: null,
      selectedOrderTypes: [],
      selectedPackages: [],
      startDateRange: {
        start: null,
        end: null,
      },
      bookingDateRange: {
        start: null,
        end: null,
      },
      campaignId: '',
      searchText: '',
      orders: [],
      currentCursor: 0,
      nextCursor: 0,
      noResults: false,
      filterBuilder: new FilterBuilder(),
      activeRoute: '',
      currentPage: 1,
      totalRows: 0,
      sortOptions: SORT_OPTIONS,
      modalVisible: false,
      modalCampaignTitle: null,
      modalCampaignId: null,
      internalNote: '',
      focModalVisible: false,
      foc: '',
      adjustmentModalVisible: false,
      adjustmentModalCampaign: null,
      adjustmentDate: null,
      adjustmentTtv: null,
      adjustmentRevenue: null,
      adjustmentNote: null,
    };
  },
  methods: {
    showModal(id, title) {
      this.modalVisible = true;
      this.modalCampaignTitle = title;
      this.modalCampaignId = id;
    },
    showFocModal(id, foc) {
      this.focModalVisible = true;
      this.modalCampaignId = id;
      this.foc = foc;
    },
    hideFocModal() {
      this.focModalVisible = false;
    },
    hideModal() {
      this.modalVisible = false;
      this.modalCampaignTitle = null;
      this.modalCampaignId = null;
      this.internalNote = '';

      this.getOrders();
    },
    adjustmentModalClosed() {
      this.adjustmentModalVisible = false;
    },
    parseInitials(value) {
      const words = value.split(' ');
      const length = words.length;
      return `${words[0].charAt(0)}.${words[length - 1].charAt(0)}.`;
    },
    async submitFoc() {
      try {
        const response = await CampaignServices.updateCampaignFoc(
          this.modalCampaignId,
          this.foc
        );

        // Update the orders array with new FOC data
        const orders = Object.assign([], this.orders);
        const index = orders.findIndex(
          (order) => order.campaign.id === this.modalCampaignId
        );

        if (index !== -1) {
          // Update both the campaign.foc and statusLabel fields
          orders[index] = {
            ...orders[index],
            campaign: {
              ...orders[index].campaign,
              statusLabel: this.foc,
            },
            statusLabel: this.foc, // Update the statusLabel that's displayed in the UI
          };

          this.orders = orders; // Trigger reactive update
        }

        this.$swal({
          type: 'success',
          title: 'Success!',
          text: 'Free of charge note added successfully.',
        });
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'Failed to add note',
          text: 'An error occurred while adding the free of charge note.',
        });
      } finally {
        this.focModalVisible = false;
        this.modalCampaignId = null;
        this.foc = '';
      }
    },
    async submitNote() {
      try {
        const response = await CampaignServices.updateCampaignNote(
          this.modalCampaignId,
          {
            note: this.internalNote,
            type: 'internal',
          }
        );

        const orders = Object.assign([], this.orders);
        const index = orders.findIndex(
          (order) => order.id === this.modalCampaignId
        );
        const order = orders[index];
        const updatedOrder = {
          ...order,
          campaign: {
            ...response,
            endDate: response.endDate
              ? format(response.endDate, 'DD MMM YYYY')
              : null,
          },
        };

        orders[index] = updatedOrder;

        this.orders = orders;

        this.$swal({
          type: 'success',
          title: 'Success!',
          text: 'Note added successfully.',
        });
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'Failed to add note',
          text: 'An error occured while adding the note.',
        });
      } finally {
        this.modalVisible = false;
        this.modalCampaignTitle = null;
        this.modalCampaignId = null;
        this.internalNote = '';
      }
    },
    async showAdjustmentModal(campaign) {
      this.adjustmentModalCampaign = campaign;
      this.adjustmentModalVisible = true;
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },
    getOrders() {
      OrderService.getOrders(
        this.filterBuilder.get(), // Add filter
        {
          field: 'campaign.createdAt',
          order: 'DESC',
        }, // Sort
        0,
        this.currentPage,
        10
      ).then((response) => {
        this.noResults = response.data.length === 0 && this.orders.length === 0;
        const normalizedData = response.data.map(function(order) {
          if (!order.campaign) return order;
          let endDate = order.campaign.endDate;

          if (order.package && order.package.type) {
            let duration = null;
            switch (order.package.type) {
              case 'property':
              case 'agent extend':
                duration = order.package.propertyDuration;
                break;
              case 'agent':
                duration = order.package.agentDuration;
                break;
              case 'office':
                duration = order.package.officeDuration;
                break;
              default:
                duration = null;
                break;
            }

            if (duration && !order.campaign.endDate) {
              const parsedDate = parse(order.campaign.startDate);
              const newDate = addDays(parsedDate, duration);
              endDate = null;
            }
          }

          if (endDate) {
            endDate = format(endDate, 'DD MMM YYYY');
          }

          return {
            ...order,
            campaign: {
              ...order.campaign,
              endDate,
            },
          };
        });

        this.orders = normalizedData;

        this.getTotalRows();
      });
    },
    clearFilters(includeClient = true) {
      if ((includeClient = true)) {
        this.selectedClients = [];
        this.orders = [];
      }
      this.selectedAgencies = [];
      this.selectedStatuses = [];
      this.selectedInvoice = null;
      this.selectedOrderTypes = [];
      this.selectedPackages = [];
      this.startDateRange = {
        start: null,
        end: null,
      };
      this.bookingDateRange = {
        start: null,
        end: null,
      };
      this.campaignId = '';
      this.searchText = '';
    },
    handleClientSelected(value) {
      this.selectedClients = [value];
      // Set selected agencies to only agencies under the selected client.
      this.selectedAgencies = [];
    },
    handleClientRemoved(value) {
      this.clearFilters();
    },
    handleAgencySelected(value) {
      this.selectedAgencies = OrderDropdownFilterSelectedHelper(
        this.selectedAgencies,
        value,
        AgencyListAllOption
      );
    },
    handleAgencyRemoved(value) {
      this.selectedAgencies = this.selectedAgencies.filter(
        (agency) => agency.id !== value.id
      );
    },
    handleStatusSelected(value) {
      this.selectedStatuses = OrderDropdownFilterSelectedHelper(
        this.selectedStatuses,
        value,
        OrderStatusListAllOption
      );
    },
    handleStatusRemoved(value) {
      this.selectedStatuses = this.selectedStatuses.filter(
        (status) => status.id !== value.id
      );
    },
    handleInvoiceSelected(value) {
      this.selectedInvoice = value;
    },
    handleInvoiceRemoved() {
      this.selectedInvoice = null;
    },
    handleOrderTypeSelected(value) {
      this.selectedOrderTypes = OrderDropdownFilterSelectedHelper(
        this.selectedOrderTypes,
        value,
        OrderTypeAllOption
      );
    },
    handleOrderTypeRemoved(value) {
      this.selectedOrderTypes = this.selectedOrderTypes.filter(
        (type) => type.id !== value.id
      );
    },
    handlePackageSelected(value) {
      this.selectedPackages = OrderDropdownFilterSelectedHelper(
        this.selectedPackages,
        value,
        PackageListAllOption
      );
    },
    handlePackageRemoved(value) {
      this.selectedPackages = this.selectedPackages.filter(
        (packageData) => packageData.id !== value.id
      );
    },
    hasGst(order) {
      return order.agency && order.agency.includeGst;
    },
    updateInvoice(order) {
      OrderService.updateInvoice(order.id, !order.invoiced).then((result) => {
        order.invoicedDate = result.invoicedDate;
        order.invoiced = result.invoiced;
      });
    },
    exportCSV() {
      var today = new Date();
      var date =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      OrderService.exportToCSV(this.filterBuilder.get(), {
        field: 'campaign.createdAt',
        order: 'DESC',
      })
        .then((blob) => {
          let url = window.URL.createObjectURL(new Blob([blob]));
          let link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Orders Export - ${date}.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    exportSignifiCSV() {
      var today = new Date();
      var date =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      OrderService.signifiExportToCSV(this.filterBuilder.get())
        .then((blob) => {
          let url = window.URL.createObjectURL(new Blob([blob]));
          let link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Signifi Orders Export - ${date}.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTotalRows() {
      OrderService.getTotalRows(this.filterBuilder.get()).then((totalRows) => {
        this.totalRows = totalRows.data;
      });
    },
    handlePageChanged(params) {
      this.currentPage = params.currentPage;
    },
    goToDashboard(order) {
      const isPropertyCampaign =
        order.campaignType == 'property' ||
        order.campaignType == 'property extend' ||
        order.campaignType == 'property just sold';
      const urlCampaignPathSegment = isPropertyCampaign
        ? 'property-campaigns'
        : 'agent-campaigns';
      const urlPath = `/office/${
        order.agency.slug.name
      }/${urlCampaignPathSegment}/${order.campaign.id}`;

      this.$router.push(urlPath);
    },
    campaignTypeNormalizer(type) {
      if (type === 'property extend') return 'Property';

      return type;
    },
    /**
     * Method to handle the query parameters present in the URL when this
     * component gets mounted, this only triggers for users who are
     * not super admins.
     */
    handleQueryParams() {
      if (Navigation.isSuperAdmin()) return;

      const urlObj = new URL(window.location);
      const queryParams = new URLSearchParams(urlObj.search);
      const filters = queryParams.get('filters')
        ? JSON.parse(queryParams.get('filters'))
        : null;

      if (filters === null) return;

      const keys = Object.keys(filters);
      keys.forEach((key) => {
        this[key] = filters[key];
      });
    },
    setActive(name) {
      this.activeRoute = name;
    },
    goToOrders() {
      this.setActive('orders');
    },
    handlePreselectedClient() {
      const isUserAdmin =
        Navigation.isClientAdmin() || Navigation.isAgencyAdmin();

      if (isUserAdmin === false) return;

      const user = this.$store.getters.getUser;

      const formattedClientName = StringToCapitalizedCase(user.client);

      this.selectedClients = [
        {
          id: user.clientId,
          title: formattedClientName,
        },
      ];
    },
  },
  computed: {
    ...mapGetters(['getOrdersFilter']),
    notes() {
      if (this.orders.length === 0) return [];

      return this.orders.find((order) => order.id === this.modalCampaignId)
        .campaign.campaignNotes;
    },
    notesColumns() {
      return NOTES_COLUMNS;
    },
    columns() {
      let normalizedColumns = Object.assign([], COLUMNS);

      if (!OrderPerimeters.isAllowed('updateInvoice')) {
        normalizedColumns = normalizedColumns.filter(
          (column) => column.field !== 'invoiced'
        );
      }

      if (!OrderPerimeters.isAllowed('viewNotes')) {
        normalizedColumns = normalizedColumns.filter(
          (column) => column.label !== 'Notes'
        );
      }

      if (!OrderPerimeters.isAllowed('viewNotes')) {
        normalizedColumns = normalizedColumns.filter(
          (column) => column.label !== 'Free of Charge'
        );
      }

      if (!OrderPerimeters.isAllowed('viewFoc')) {
        normalizedColumns = normalizedColumns.filter(
          (column) => column.label !== 'Finance Adjustments'
        );
      }

      // Remove invoice column if user is unable to update invoice
      return normalizedColumns;
    },
    paginationOptions() {
      return {...PAGINATION_OPTIONS, setCurrentPage: this.currentPage};
    },
    agenciesDropdownFilter() {
      if (
        this.selectedClients.length === 1 &&
        this.selectedClients[0].id === ClientListAllOption.id
      ) {
        return [];
      }

      return this.selectedClients.map((client) => client.id);
    },
    noClientSelected() {
      return this.selectedClients.length === 0;
    },
    /**
     * A wrapper around our filters so that we can have the ability to watch
     * all of these in a single watcher method rather than declaring one
     * watcher for each value.
     *
     * This computed value will will have keys that correspond to the filters
     * the API is expected.
     */
    watchedFilterBuilderValues() {
      return {
        // Mapped = properties that are mapped to the API request
        mapped: {
          client: this.selectedClients.flatMap((client) => client.id),
          agency: this.selectedAgencies.flatMap((agency) => agency.id),
          status: this.selectedStatuses.flatMap((status) => status.id),
          invoiced: this.selectedInvoice || [],
          campaignType: this.selectedOrderTypes.flatMap((type) => type.id),
          packages: this.selectedPackages.flatMap(
            (packageData) => packageData.id
          ),
          dateFrom: this.startDateRange.start,
          dateTo: this.startDateRange.end,
          bookingDateFrom: this.bookingDateRange.start,
          bookingDateTo: this.bookingDateRange.end,
          campaignId: this.campaignId,
          searchText: this.searchText,
        },
        // Unmapped = property names that are based on their actual names.
        unmapped: {
          selectedClients: this.selectedClients,
          selectedAgencies: this.selectedAgencies,
          selectedStatuses: this.selectedStatuses,
          selectedInvoice: this.selectedInvoice || [],
          selectedOrderTypes: this.selectedOrderTypes,
          selectedPackages: this.selectedPackages,
          startDateRange: this.startDateRange,
          bookingDateRange: this.bookingDateRange,
        },
      };
    },
  },
  watch: {
    watchedFilterBuilderValues: {
      handler: function(value) {
        // Reset orders when filter has changed
        this.orders = [];
        this.currentPage = 1;
        this.noResults = false;
        // Clone incoming object
        const filters = Object.assign({}, value);
        const mappedFilters = Object.assign({}, filters.mapped);
        const keys = Object.keys(mappedFilters);

        this.filterBuilder.updateFilter('order', 'latest');

        keys.forEach((key) => {
          if (Array.isArray(mappedFilters[key])) {
            let filteredArray = mappedFilters[key].filter((val) => val); // Remove empty values
            if (filteredArray.length === 0) {
              this.filterBuilder.removeFilter(key);
            } else {
              this.filterBuilder.updateFilter(key, filteredArray);
            }
          } else {
            if (!mappedFilters[key]) {
              this.filterBuilder.removeFilter(key);
            } else {
              this.filterBuilder.updateFilter(key, mappedFilters[key]);
            }
          }
        });

        // Check if the current route's query matches the new query
        const queryFilters = JSON.stringify(filters.unmapped);

        if (JSON.stringify(this.$route.query) !== queryFilters) {
          this.$router.push({
            path: this.$route.fullPath,
            query: {
              filters: queryFilters,
            },
          });
        }
      },
      deep: true,
    },
    currentPage: {
      handler(value) {
        if (value === 0) return;
        this.getOrders();
      },
    },
  },
  mounted() {
    this.handleQueryParams();
    this.handlePreselectedClient();
    this.registerApis(['ADD-ADJUSTMENTS-API', 'SAVE-ADJUSTMENT-NOTE-API']);
  },
};
</script>

<style scoped>
.tooltip {
  visibility: hidden;
  background-color: black;
  color: white;
  text-align: center;
  padding: 5px;
  border-radius: 4px;
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.2s;
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

div#DateTimePicker.adjustment-date-picker > div > input.field-input {
  border-radius: 0px !important;
}

.badge-draft {
  background-color: #ffb30f;
  color: black;
}
</style>
